import { createSlice } from '@reduxjs/toolkit';

const initialState: initialStateType = {
  token: '',
  signedIn: false,
  isSigningOut: false,
};

export const sessionSlice = createSlice({
  name: 'auth/session',
  initialState: initialState,
  reducers: {
    onSignInSuccess: (state, action) => {
      state.signedIn = true;
      state.token = action.payload;
    },
    onStartSigningOut: (state) => {
      state.isSigningOut = true;
    },
    onStopSigningOut: (state) => {
      state.isSigningOut = false;
    },
    onSignOutSuccess: (state) => {
      state.signedIn = false;
      state.token = '';
    },
    setToken: (state, action) => {
      state.token = action.payload;
    },
  },
});

export const { onSignInSuccess, onSignOutSuccess, setToken, onStartSigningOut, onStopSigningOut } = sessionSlice.actions;
export default sessionSlice.reducer;
interface initialStateType {
  token: string;
  signedIn: boolean;
  isSigningOut: boolean;
}
